import { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import ManagdPageLoader from './ManagdPageLoader';
import { hasPendingInformation, subscribeInformationLoading } from '../utils/dataLoading';
// This component lives outside the router, so completing bootstrap survives navigation.
export default function PageLoader() {
    const pending = useSyncExternalStore(subscribeInformationLoading, hasPendingInformation, () => false)
    const started = useRef(false)
    const [finished, setFinished] = useState(false)
    useEffect(() => {
        if (pending) started.current = true
        if (!pending && started.current && !finished) {
            const timer = setTimeout(() => setFinished(true), 150)
            return () => clearTimeout(timer)
        }
    }, [pending, finished])
    return <ManagdPageLoader visible={!finished && pending} globalIndicator message="Loading…" />
}
